import { render, staticRenderFns } from "./menu-btn.vue?vue&type=template&id=1c5d9e1c&"
import script from "./menu-btn.vue?vue&type=script&lang=js&"
export * from "./menu-btn.vue?vue&type=script&lang=js&"
import style0 from "./menu-btn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports